module.exports = __webpack_public_path__ + "components/promo-app/static/app-desktop-bg-f24fa2a348fa1eaf19f46c91c91d7f74.jpg";